
        import { initEditor } from './js/editor.js';
        import { getApiUrl, CONFIG } from './js/config.js';
        import { showSocialModal } from './js/lazy-load.js';

        // 初始化编辑器
        const editor = initEditor();

        const previewFrame = document.getElementById('preview-frame');
        const clearBtn = document.getElementById('clear-btn');
        const consoleOutput = document.getElementById('console-output');
        const fullscreenBtn = document.getElementById('fullscreen-btn');
        const previewContainer = document.querySelector('.preview-container');
        const saveBtn = document.getElementById('save-btn');

        // 保存HTML文件功能
        function saveHtmlFile(htmlContent) {
            // 创建Blob对象
            const blob = new Blob([htmlContent], { type: 'text/html' });

            // 创建下载链接
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'index.html'; // 设置下载文件名

            // 添加到文档并触发点击
            document.body.appendChild(a);
            a.click();

            // 清理
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }

        // 初始化保存按钮事件
        if (saveBtn) {
            saveBtn.addEventListener('click', () => {
                gtag('event', 'button_click', {
                    'event_name': 'btn_save',
                    'web_type': 'index'
                });
                const htmlContent = editor.getValue();
                // 检查是否为空
                if (!htmlContent) {
                    showMessage('请先编写一些代码再保存', 'error');
                    return;
                }
                saveHtmlFile(htmlContent);
            });
        }

        // 错误信息输出函数
        function logError(message, stack) {
            const consoleContainer = document.querySelector('.console-container');
            const timestamp = new Date().toLocaleTimeString();
            const logEntry = document.createElement('div');
            logEntry.className = 'console-entry error';

            // 创建错误消息元素
            const messageDiv = document.createElement('div');
            messageDiv.className = 'error-message';
            messageDiv.innerHTML = `<span class="timestamp">[${timestamp}]</span> ${message}`;

            // 创建复制按钮
            const copyBtn = document.createElement('button');
            copyBtn.className = 'copy-error-btn';
            copyBtn.textContent = '复制';
            copyBtn.onclick = async function () {
                let copyText = `错误信息: ${message}\n`;
                if (stack) {
                    copyText += `堆栈信息:\n${stack}`;
                }

                try {
                    if (navigator.clipboard && navigator.clipboard.writeText) {
                        await navigator.clipboard.writeText(copyText);
                    } else {
                        const tempInput = document.createElement('textarea');
                        tempInput.style.position = 'fixed';
                        tempInput.style.opacity = '0';
                        tempInput.value = copyText;
                        document.body.appendChild(tempInput);
                        tempInput.select();
                        document.execCommand('copy');
                        document.body.removeChild(tempInput);
                    }

                    copyBtn.textContent = '已复制';
                    copyBtn.classList.add('copied');
                    setTimeout(() => {
                        copyBtn.textContent = '复制';
                        copyBtn.classList.remove('copied');
                    }, 2000);
                } catch (err) {
                    console.error('复制失败:', err);
                    copyBtn.textContent = '复制失败';
                    copyBtn.classList.add('copy-error');
                    setTimeout(() => {
                        copyBtn.textContent = '复制';
                        copyBtn.classList.remove('copy-error');
                    }, 2000);
                }
            };

            if (stack) {
                const stackDiv = document.createElement('div');
                stackDiv.className = 'error-stack';
                stackDiv.textContent = stack;
                logEntry.appendChild(messageDiv);
                logEntry.appendChild(stackDiv);
            } else {
                logEntry.appendChild(messageDiv);
            }

            logEntry.appendChild(copyBtn);
            consoleOutput.appendChild(logEntry);
            consoleOutput.scrollTop = consoleOutput.scrollHeight;
            showConsole();
        }

        // 在写入内容之前设置错误处理程序
        const errorHandlerScript = `
            <script>
            window.onerror = function(msg, url, line, col, error) {
                if (error && error.stack) {
                    window.parent.logError('Uncaught ' + error.name + ': ' + error.message, error.stack);
                } else {
                    window.parent.logError('Uncaught Error: ' + msg + ' (行: ' + line + ', 列: ' + col + ')');
                }
                return true;
            };

            console.error = function(error) {
                if (error instanceof Error) {
                    window.parent.logError(error.name + ': ' + error.message, error.stack);
                } else {
                    window.parent.logError('Error: ' + Array.from(arguments).join(' '));
                }
            };
            <\/script>
        `;

        // 实时预览功能
        function updatePreview() {
            const code = editor.getValue();
            consoleOutput.innerHTML = ''; // 清除旧的错误
            checkAndToggleConsole(); // 检查是否需要隐藏控制台

            try {
                // 创建一个新的iframe元素
                const newFrame = document.createElement('iframe');
                newFrame.id = 'preview-frame';
                const oldFrame = document.getElementById('preview-frame');
                oldFrame.parentNode.replaceChild(newFrame, oldFrame);

                // 获取新的预览文档
                const previewDoc = newFrame.contentDocument || newFrame.contentWindow.document;

                // 将错误处理程序注入到预览内容中
                const modifiedCode = code.replace('</head>', errorHandlerScript + '</head>');

                // 更新预览
                previewDoc.open();
                previewDoc.write(modifiedCode);
                previewDoc.close();

            } catch (error) {
                logError(error.name + ': ' + error.message, error.stack);
            }
        }

        // 检查JavaScript错误
        function checkJSErrors(code) {
            const errors = [];
            try {
                // 提取JavaScript代码
                const scriptRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
                let match;

                while ((match = scriptRegex.exec(code)) !== null) {
                    const jsCode = match[1].trim();
                    if (jsCode) {
                        try {
                            // 尝试执行JavaScript代码
                            new Function(jsCode);
                        } catch (e) {
                            return [{ message: e.message, stack: e.stack }];
                        }
                    }
                }
            } catch (e) {
                return [{ message: e.message, stack: e.stack }];
            }
            return errors;
        }

        // 检查HTML语法错误
        function checkHTMLErrors(code) {
            const errors = [];
            const parser = new DOMParser();
            const doc = parser.parseFromString(code, 'text/html');

            // 只检查严重的解析错误
            const parseError = doc.querySelector('parsererror');
            if (parseError) {
                errors.push({
                    message: 'HTML Parse Error',
                    stack: parseError.textContent
                });
            }

            return errors;
        }

        // 清除代码功能
        clearBtn.addEventListener('click', () => {
            gtag('event', 'button_click', {
                'event_name': 'btn_clear',
                'web_type': 'index'
            });
            editor.setValue('');
            consoleOutput.innerHTML = '';
            // 隐藏控制台
            document.querySelector('.console-container').classList.remove('show');
            updatePreview();
        });

        // 粘贴代码功能
        const pasteBtn = document.getElementById('paste-btn');
        pasteBtn.addEventListener('click', async () => {
            gtag('event', 'button_click', {
                'event_name': 'btn_paste',
                'web_type': 'index'
            });
            try {
                // 尝试使用现代的 Clipboard API
                if (navigator.clipboard && navigator.clipboard.readText) {
                    const text = await navigator.clipboard.readText();
                    editor.setValue(text);
                    updatePreview();
                } else {
                    // 后备方案：使用传统的 execCommand
                    const textarea = document.createElement('textarea');
                    textarea.style.position = 'fixed';
                    textarea.style.opacity = '0';
                    document.body.appendChild(textarea);
                    textarea.focus();

                    if (document.execCommand('paste')) {
                        const text = textarea.value;
                        editor.setValue(text);
                        updatePreview();
                    } else {
                        showMessage('当前浏览器无法访问剪贴板，请手动粘贴', 'error');
                    }

                    document.body.removeChild(textarea);
                }
            } catch (error) {
                console.error('粘贴失败:', error);
                showMessage('粘贴失败: ' + error.message, 'error');
            }
        });

        // 将logError函数暴露给iframe
        window.logError = logError;

        // 检查是否有错误并相应地显示/隐藏控制台
        function showConsole() {
            const consoleContainer = document.querySelector('.console-container');
            if (!consoleContainer.classList.contains('show')) {
                consoleContainer.classList.add('show');
                // 如果是第一次显示错误控制台，触发引导
                if (!localStorage.getItem('hasVisitedConsole')) {
                    // 给一个小延迟确保控制台完全显示
                    setTimeout(() => {
                        initConsoleGuide();
                    }, 300);
                }
            }
        }

        function checkAndToggleConsole() {
            const consoleContainer = document.querySelector('.console-container');
            const hasErrors = consoleOutput.children.length > 0;

            if (hasErrors) {
                showConsole();
            } else {
                consoleContainer.classList.remove('show');
            }
        }

        // 监听代码变化
        editor.on('change', () => {
            updatePreview();
        });

        // 初始化预览
        updatePreview();

        // 全屏预览功能
        fullscreenBtn.addEventListener('click', () => {
            gtag('event', 'button_click', {
                'event_name': 'btn_fullscreen',
                'web_type': 'index'
            });
            if (!document.fullscreenElement) {
                // 进入全屏
                if (previewContainer.requestFullscreen) {
                    previewContainer.requestFullscreen();
                } else if (previewContainer.webkitRequestFullscreen) {
                    previewContainer.webkitRequestFullscreen();
                } else if (previewContainer.msRequestFullscreen) {
                    previewContainer.msRequestFullscreen();
                }
                previewContainer.classList.add('fullscreen');
                fullscreenBtn.textContent = '退出全屏';
            } else {
                // 退出全屏
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                previewContainer.classList.remove('fullscreen');
                fullscreenBtn.textContent = '全屏预览';
            }
        });

        // 监听全屏变化事件
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('msfullscreenchange', handleFullscreenChange);

        function handleFullscreenChange() {
            if (!document.fullscreenElement &&
                !document.webkitFullscreenElement &&
                !document.msFullscreenElement) {
                previewContainer.classList.remove('fullscreen');
                fullscreenBtn.textContent = '全屏预览';
            }
        }

        // 上传代码功能
        const publishBtn = document.getElementById('publish-btn');
        const publishStatus = document.getElementById('publish-status');
        let isPublishing = false;
        let lastPublishTime = 0;
        let uploadedCodes = [];
        const PUBLISH_COOLDOWN = 10000; // 10秒冷却时间

        function showMessage(message, type = 'info') {
            const messageDiv = document.createElement('div');
            messageDiv.className = `status-message ${type}`;
            messageDiv.textContent = message;
            document.body.appendChild(messageDiv);

            setTimeout(() => {
                messageDiv.remove();
            }, 3000);
        }

        publishBtn.addEventListener('click', async () => {
            gtag('event', 'button_click', {
                'event_name': 'btn_upload',
                'web_type': 'index'
            });
            // 获取当前时间
            const now = Date.now();

            // 检查是否在上传中
            if (isPublishing) {
                showMessage('上传进行中，请稍候...', 'warning');
                return;
            }

            // 检查冷却时间
            const timeSinceLastPublish = now - lastPublishTime;
            if (timeSinceLastPublish < PUBLISH_COOLDOWN) {
                const remainingSeconds = Math.ceil((PUBLISH_COOLDOWN - timeSinceLastPublish) / 1000);
                showMessage(`请等待 ${remainingSeconds} 秒后再试`, 'warning');
                // 添加冷却状态视觉反馈
                publishBtn.classList.add('cooldown');
                setTimeout(() => {
                    publishBtn.classList.remove('cooldown');
                }, 500);
                return;
            }

            // 检查内容是否为空
            const htmlContent = editor.getValue().trim();
            if (!htmlContent) {
                showMessage('请先编写一些代码再上传', 'error');
                // 添加空内容状态视觉反馈
                publishBtn.classList.add('empty');
                setTimeout(() => {
                    publishBtn.classList.remove('empty');
                }, 500);
                return;
            }

            // 检查是否是默认代码
            if (htmlContent === CONFIG.defaultCode.trim()) {
                showMessage('默认代码不能上传，请添加自己的代码', 'error');
                // 添加默认代码状态视觉反馈
                publishBtn.classList.add('default-code');
                setTimeout(() => {
                    publishBtn.classList.remove('default-code');
                }, 500);
                return;
            }

            // 检查是否已经上传过相同的代码
            if (uploadedCodes.includes(htmlContent)) {
                showMessage('相同的代码已上传，请修改后再试', 'error');
                // 添加重复代码状态视觉反馈
                publishBtn.classList.add('duplicate');
                setTimeout(() => {
                    publishBtn.classList.remove('duplicate');
                }, 500);
                return;
            }

            // 设置上传状态
            isPublishing = true;
            lastPublishTime = now;

            // 创建Blob对象
            const htmlBlob = new Blob([htmlContent], { type: 'text/html' });

            // 创建FormData对象
            const formData = new FormData();
            formData.append('html', htmlBlob, 'index.html');
            formData.append('type', 'index');

            // 禁用上传按钮，显示上传中状态
            publishBtn.disabled = true;
            publishBtn.classList.add('publishing');
            publishBtn.textContent = '上传中...';

            try {
                const response = await fetch(getApiUrl('upload'), {
                    method: 'POST',
                    body: formData
                });

                const data = await response.json();

                if (response.ok && data.success) {
                    uploadedCodes.push(htmlContent);
                    // 显示成功模态框
                    const successModal = document.getElementById('success-modal');
                    const successPreview = document.getElementById('success-preview');
                    const shareBtn = document.getElementById('share-btn');
                    const visitBtn = document.getElementById('visit-btn');

                    // 设置预览iframe的src
                    const previewUrl = data.url;
                    const fullUrl = data.url;
                    successPreview.src = previewUrl;
                    // successPreview.src = 'http://localhost:8000/index.html';

                    // 添加错误处理
                    successPreview.onerror = () => {
                        const errorMessage = document.createElement('div');
                        errorMessage.className = 'preview-error';
                        errorMessage.innerHTML = `
                            <svg viewBox="0 0 24 24" class="error-icon">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                            </svg>
                            <p>预览加载失败</p>
                            <p class="error-detail">由于安全限制，无法在iframe中预览页面</p>
                            <button class="preview-error-btn" onclick="window.open('${fullUrl}', '_blank')">
                                在新窗口打开
                            </button>
                        `;
                        successPreview.parentNode.appendChild(errorMessage);
                    };

                    // 显示模态框
                    successModal.classList.add('show');

                    // 设置分享按钮点击事件
                    shareBtn.onclick = async () => {
                        try {
                            // 尝试使用 clipboard API
                            if (navigator.clipboard && navigator.clipboard.writeText) {
                                await navigator.clipboard.writeText(fullUrl);
                            } else {
                                // 后备方案：创建临时输入框
                                const tempInput = document.createElement('input');
                                tempInput.style.position = 'fixed';
                                tempInput.style.opacity = '0';
                                tempInput.value = fullUrl;
                                document.body.appendChild(tempInput);
                                tempInput.select();
                                document.execCommand('copy');
                                document.body.removeChild(tempInput);
                            }

                            // 更新按钮状态
                            shareBtn.innerHTML = `
                                <svg viewBox="0 0 24 24">
                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                                </svg>
                                已复制
                            `;
                            setTimeout(() => {
                                shareBtn.innerHTML = `
                                    <svg viewBox="0 0 24 24">
                                        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
                                    </svg>
                                    分享链接
                                `;
                            }, 2000);
                        } catch (err) {
                            console.error('复制失败:', err);
                            // 在复制失败时显示提示
                            shareBtn.innerHTML = `
                                <svg viewBox="0 0 24 24">
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                                </svg>
                                复制失败
                            `;
                            setTimeout(() => {
                                shareBtn.innerHTML = `
                                    <svg viewBox="0 0 24 24">
                                        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/>
                                    </svg>
                                    分享链接
                                `;
                            }, 2000);
                        }
                    };

                    // 设置访问按钮点击事件
                    visitBtn.onclick = () => {
                        window.open(fullUrl, '_blank');
                    };

                    // 设置关闭按钮点击事件
                    const modalCloseBtn = document.getElementById('modal-close-btn');
                    modalCloseBtn.onclick = () => {
                        successModal.classList.remove('show');
                    };

                    // 点击模态框外部关闭
                    successModal.onclick = (e) => {
                        if (e.target === successModal) {
                            successModal.classList.remove('show');
                        }
                    };
                } else {
                    throw new Error(data.error || '上传失败');
                }
            } catch (error) {
                console.error('Error:', error);
                showMessage('上传失败: ' + error.message, 'error');
            } finally {
                // 恢复上传状态
                isPublishing = false;
                publishBtn.disabled = false;
                publishBtn.classList.remove('publishing');
                publishBtn.textContent = '上传代码';
            }
        });

        // 控制台拖动调整大小功能
        const consoleContainer = document.querySelector('.console-container');
        const dragHandle = document.querySelector('.console-drag-handle');
        const editorWrapper = document.querySelector('.editor-wrapper');
        let isDragging = false;
        let startY;
        let startHeight;
        let startEditorHeight;

        dragHandle.addEventListener('mousedown', (e) => {
            isDragging = true;
            startY = e.clientY;
            startHeight = parseInt(getComputedStyle(consoleContainer).height, 10);
            startEditorHeight = parseInt(getComputedStyle(editorWrapper).height, 10);

            document.body.style.cursor = 'ns-resize';
            document.body.style.userSelect = 'none';
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;

            const deltaY = startY - e.clientY;
            const newHeight = Math.min(
                Math.max(30, startHeight + deltaY),
                editorWrapper.parentElement.clientHeight - 50
            );

            consoleContainer.style.height = newHeight + 'px';

            // 更新编辑器大小
            const editorContainer = document.querySelector('.editor-container');
            const totalHeight = editorContainer.clientHeight;
            const newEditorHeight = totalHeight - newHeight;
            editorWrapper.style.height = newEditorHeight + 'px';

            // 通知 CodeMirror 更新大小
            editor.refresh();
        });

        document.addEventListener('mouseup', () => {
            if (isDragging) {
                isDragging = false;
                document.body.style.cursor = '';
                document.body.style.userSelect = '';
            }
        });

        // 社交媒体弹窗功能
        // const editorLogo = document.getElementById('editor-logo');
        const socialModal = document.getElementById('social-modal');
        const socialModalClose = document.getElementById('social-modal-close');

        // editorLogo.addEventListener('click', () => {
        //     gtag('event', 'button_click', {
        //         'event_name': 'btn_social',
        //         'web_type': 'index'
        //     });
        //     showSocialModal();
        // });

        socialModalClose.addEventListener('click', () => {
            socialModal.classList.remove('show');
        });

        // 点击弹窗外部关闭
        socialModal.addEventListener('click', (e) => {
            if (e.target === socialModal) {
                socialModal.classList.remove('show');
            }
        });

        // 添加图片点击放大功能
        document.querySelectorAll('.qr-code img').forEach(img => {
            img.addEventListener('click', () => {
                const modal = document.querySelector('.image-preview-modal');
                const previewImage = modal.querySelector('.preview-image');
                // 使用当前显示的图片源
                previewImage.src = img.src;
                modal.classList.add('show');
            });
        });

        // 关闭图片预览
        document.querySelector('.image-preview-close').addEventListener('click', () => {
            document.querySelector('.image-preview-modal').classList.remove('show');
        });

        // 点击背景关闭预览
        document.querySelector('.image-preview-modal').addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                e.currentTarget.classList.remove('show');
            }
        });
    